<template>
  <div class="flex">
    <context-menu :show="isShowContextProcess" :options="optionsContext">
      <context-menu-item label="올리기" @click="onProcessUp" />
      <context-menu-item label="내리기" @click="onProcessDown" />
      <context-menu-sperator />
      <context-menu-item label="삭제" @click="onProcessDelete" />
      <context-menu-sperator />
      <context-menu-group label="두께">
        <div class="flex items-center px-3 py-1 text-md">
          <span style="min-width: 2.2rem">경고</span>
          <input
            class="w-10"
            type="text"
            v-model="processThickWarn"
            @change="onChange"
            @input="onInputTickWarn(processThickWarn)"
            @blur="onInputBlur"
          />
        </div>
        <div class="flex items-center px-3 py-1 text-md">
          <span style="min-width: 2.2rem">주의</span>
          <input
            class="w-10"
            type="text"
            v-model="procesThickCaution"
            @change="onChange"
            @input="onInputTickCaution(procesThickCaution)"
            @blur="onInputBlur"
          />
        </div>
      </context-menu-group>
      <context-menu-group label="뭉개짐">
        <div class="flex items-center px-3 py-1 text-md">
          <span style="min-width: 2.2rem">경고</span>
          <input
            class="w-10"
            type="text"
            v-model="processGapWarn"
            @change="onChange"
            @input="onInputGapWarn(processGapWarn)"
            @blur="onInputBlur"
          />
        </div>
        <div class="flex items-center px-3 py-1 text-md">
          <span style="min-width: 2.2rem">주의</span>
          <input
            class="w-10"
            type="text"
            v-model="processGapCaution"
            @change="onChange"
            @input="onInputGapCaution(processGapCaution)"
            @blur="onInputBlur"
          />
        </div>
      </context-menu-group>
    </context-menu>
    <context-menu :show="isShowContextMaterial" :options="optionsContext">
      <context-menu-item label="올리기" @click="onMaterialUp" />
      <context-menu-item label="내리기" @click="onMaterialDown" />
      <context-menu-sperator />
      <context-menu-item label="삭제" @click="onMaterialDelete" />
    </context-menu>
    <context-menu :show="isShowContextCompany" :options="optionsContext">
      <context-menu-item label="올리기" @click="onCompanyUp" />
      <context-menu-item label="내리기" @click="onCompanyDown" />
      <context-menu-sperator />
      <context-menu-item label="삭제" @click="onCompanyDelete" />
    </context-menu>
    <div class="kfo2-col-process" style="min-width: 10rem; max-width: 10rem">
      <div>
        <div class="flex">
          <button @click="onEditProcess"><i class="fi fi-br-menu-dots-vertical"></i></button>
          <div class="cs-form cs-form-noline" data-height="xs">
            <input class="" v-model="processName" type="text" placeholder="" @change="onChange" />
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div
        class="flex border-b border-line"
        v-for="material in props.process.matarials"
        :key="material.id"
      >
        <div class="kfo2-col-material" style="min-width: 12rem; max-width: 12rem">
          <div class="flex">
            <button @click="onEditMaterial($event, material)">
              <i class="fi fi-br-menu-dots-vertical"></i>
            </button>

            <div class="cs-form cs-form-noline" data-height="xs">
              <input class="" v-model="material.name" type="text" placeholder="" />
            </div>
          </div>
        </div>
        <div class="">
          <div
            class="flex border-b border-line"
            v-for="company in material.companys"
            :key="company.id"
          >
            <div class="kfo2-col-company" style="min-width: 13rem">
              <div class="flex">
                <button @click="onEditCompany($event, company)">
                  <i class="fi fi-br-menu-dots-vertical"></i>
                </button>
                <div class="cs-form cs-form-noline" data-height="xs">
                  <input class="" v-model="company.name" type="text" placeholder="" />
                </div>
              </div>
            </div>
            <div class="kfo2-col-company" style="min-width: 15rem">
              <div class="cs-form cs-form-noline" data-height="xs">
                <input class="" v-model="company.printer" type="text" placeholder="" />
              </div>
            </div>
            <div class="flex kfo2-col-company" style="min-width: 16.5rem">
              <div class="mr-2 cs-form cs-form-noline" data-height="xs">
                <input
                  class=""
                  v-model="company.buildX"
                  type="text"
                  placeholder=""
                  @input="onInputSize(company)"
                  @blur="onInputBlurSize(company)"
                />
              </div>
              <span class="m-auto">x</span>
              <div class="mr-2 ml-2 cs-form cs-form-noline" data-height="xs">
                <input
                  class=""
                  v-model="company.buildY"
                  type="text"
                  placeholder=""
                  @input="onInputSize(company)"
                  @blur="onInputBlurSize(company)"
                />
              </div>
              <span class="m-auto">x</span>
              <div class="ml-2 cs-form cs-form-noline" data-height="xs">
                <input
                  class=""
                  v-model="company.buildZ"
                  type="text"
                  placeholder=""
                  @input="onInputSize(company)"
                  @blur="onInputBlurSize(company)"
                />
              </div>
            </div>
            <div
              class="flex justify-center items-center kfo2-col-company"
              style="min-width: 5rem; max-width: 5rem"
            >
              <input
                class="m-auto form-check-input"
                id="term"
                type="checkbox"
                :checked="company.isPaint"
                v-model="company.isPaint"
              />
            </div>
            <div
              class="flex justify-center items-center kfo2-col-company"
              style="min-width: 5rem; max-width: 5rem"
            >
              <input
                class="m-auto form-check-input"
                id="term"
                type="checkbox"
                :checked="company.isPostProcess"
                v-model="company.isPostProcess"
              />
            </div>
            <div class="kfo2-col-company" style="min-width: 6rem">
              <div class="cs-form cs-form-noline" data-height="xs">
                <input
                  class="text-right"
                  v-model="company.costRate"
                  type="text"
                  placeholder=""
                  @input="onInputPriceRatio(company)"
                  @blur="onInputBlurPriceRatio(company)"
                />
              </div>
            </div>
            <div class="kfo2-col-company" style="min-width: 9rem">
              <div class="cs-form cs-form-noline" data-height="xs">
                <input
                  class="text-right"
                  v-model="company.minCost"
                  type="text"
                  placeholder=""
                  @keyup="company.minCost = numberComma(company.minCost)"
                  @blur="onInputNumber(company)"
                />
              </div>
            </div>
            <div class="kfo2-col-company" style="min-width: 9rem">
              <div class="cs-form cs-form-noline" data-height="xs">
                <input
                  class="text-right"
                  v-model="company.useCost"
                  type="text"
                  placeholder=""
                  @keyup="company.useCost = numberComma(company.useCost)"
                  @blur="onInputNumber(company)"
                />
              </div>
            </div>
            <div class="kfo2-col-company" style="min-width: 9rem; border-width: 0px">
              <div class="cs-form cs-form-noline" data-height="xs">
                <input
                  class="text-right"
                  v-model="company.materialCost"
                  type="text"
                  placeholder=""
                  @keyup="company.materialCost = numberComma(company.materialCost)"
                  @blur="onInputNumber(company)"
                />
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="kfo2-col-company" style="min-width: 13rem; max-width: 12rem">
              <div class="cs-form" data-height="xs">
                <input
                  class=""
                  v-model="material.companyName"
                  type="text"
                  placeholder=""
                  @keypress.enter="onAddCompany(material)"
                />
              </div>
            </div>
            <div style="min-width: 67rem"></div>
          </div>
        </div>
      </div>

      <div class="flex border-b border-line2">
        <div class="kfo2-col-material" style="min-width: 12rem; max-width: 12rem">
          <div class="cs-form" data-height="xs">
            <input
              class=""
              v-model="materialName"
              type="text"
              placeholder=""
              @keypress.enter="onAddMaterial"
            />
          </div>
        </div>
        <div style="min-width: 79rem"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
/******************************************
 * 하이쓰리디 - 설정의 재료 및 협력사 리스트 행
 ******************************************/

import {ref} from "vue";
import {toast} from "vue3-toastify";
import {numberToComma, removeComma} from "../../js/utils";
import {CompanyStore} from "../../store/company-store";

const props = defineProps({
  process: {type: Object},
});

let processName = ref(props.process.name);
let processThickWarn = ref("" + props.process.thicknessWarn);
let procesThickCaution = ref("" + props.process.thicknessCaution);
let processGapWarn = ref("" + props.process.gapWarn);
let processGapCaution = ref("" + props.process.gapCaution);
let materialName = ref("");

let currentMaterial = null;
let currentCompany = null;

let isShowContextProcess = ref(false);
let isShowContextMaterial = ref(false);
let isShowContextCompany = ref(false);
const optionsContext = ref({
  clickClose: true,
  zIndex: 3,
  minWidth: 130,
  x: 500,
  y: 200,
  onClose: () => {
    isShowContextProcess.value = false;
    isShowContextMaterial.value = false;
    isShowContextCompany.value = false;
  },
});

const companyStore = CompanyStore();

const onChange = () => {
  CompanyStore().updateProcess({
    id: props.process.id,
    name: processName.value,
    thickWarn: processThickWarn.value,
    thickCaution: procesThickCaution.value,
    gapWarn: processGapWarn.value,
    gapCaution: processGapCaution.value,
  });
};

const onInputTickWarn = (value) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    processThickWarn.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    processThickWarn.value = processThickWarn.value.replace(/(^0+)/, "");
  }
};
const onInputTickCaution = (value) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    procesThickCaution.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    procesThickCaution.value = procesThickCaution.value.replace(/(^0+)/, "");
  }
};
const onInputGapWarn = (value) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    processGapWarn.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    processGapWarn.value = processGapWarn.value.replace(/(^0+)/, "");
  }
};
const onInputGapCaution = (value) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    processGapCaution.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    processGapCaution.value = processGapCaution.value.replace(/(^0+)/, "");
  }
};
const onInputBlur = () => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test("" + processThickWarn.value)) {
    processThickWarn.value = "0";
  }
  if (!regExp.test("" + procesThickCaution.value)) {
    procesThickCaution.value = "0";
  }
  if (!regExp.test("" + processGapWarn.value)) {
    processGapWarn.value = "0";
  }
  if (!regExp.test("" + processGapCaution.value)) {
    processGapCaution.value = "0";
  }

  let split = processThickWarn.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    processThickWarn.value = "0";
  }
  split = procesThickCaution.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    procesThickCaution.value = "0";
  }
  split = processGapWarn.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    processGapWarn.value = "0";
  }
  split = processGapCaution.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    processGapCaution.value = "0";
  }

  if (!processThickWarn.value.length) {
    processThickWarn.value = "0";
  }
  if (!procesThickCaution.value.length) {
    procesThickCaution.value = "0";
  }
  if (!processGapWarn.value.length) {
    processGapWarn.value = "0";
  }
  if (!processGapCaution.value.length) {
    processGapCaution.value = "0";
  }

  onChange();
};

const onInputSize = (company) => {
  const regExp = /^\d{0,10}$/;
  if (!regExp.test(company.buildX)) {
    company.buildX = company.buildX.substring(0, company.buildX.length - 1);
  }
  if (!regExp.test(company.buildY)) {
    company.buildY = company.buildX.substring(0, company.buildY.length - 1);
  }
  if (!regExp.test(company.buildZ)) {
    company.buildZ = company.buildZ.substring(0, company.buildZ.length - 1);
  }
  company.buildX = company.buildX.replace(/(^0+)/, "");
  company.buildY = company.buildY.replace(/(^0+)/, "");
  company.buildZ = company.buildZ.replace(/(^0+)/, "");
};
const onInputBlurSize = (company) => {
  if (0 === company.buildX.length) {
    company.buildX = "0";
  }
  if (0 === company.buildY.length) {
    company.buildY = "0";
  }
  if (0 === company.buildZ.length) {
    company.buildZ = "0";
  }
};

const onInputPriceRatio = (company) => {
  company.costRate = company.costRate.replace(/[^0-9.]/g, "");
};
const onInputBlurPriceRatio = (company) => {
  if ("number" === typeof company.costRate) {
    return;
  }

  if (0 < company.costRate.length) {
    if ("." === company.costRate[0]) {
      company.costRate = "0" + company.costRate;
    }
  }
};

const numberComma = (src) => {
  const removeSrc = removeComma(src);

  const regExp = /^\d{0,10}$/;
  if (!regExp.test(removeSrc)) {
    return "";
  }

  if (removeSrc.length) {
    const ret = numberToComma(Number.parseInt(removeSrc));
    return ret;
  }

  return "";
};
const onInputNumber = (company) => {
  if (0 === company.minCost.length) {
    company.minCost = "0";
  }
  if (0 === company.useCost.length) {
    company.useCost = "0";
  }
  if (0 === company.materialCost.length) {
    company.materialCost = "0";
  }
};

const onAddMaterial = (e) => {
  if (1 >= e.target.value.length || 45 <= e.target.value.length) {
    toast.error("2자 이상 45자 이하로 입력해주세요.", {
      transition: toast.TRANSITIONS.SLIDE,
      position: toast.POSITION.TOP_CENTER,
    });
    return;
  }

  companyStore.addMaterial(props.process.id, materialName.value);
  materialName.value = "";
};
const onAddCompany = (material) => {
  companyStore.addCompany(props.process.id, material.id, material.companyName);
  material.companyName = "";
};

// Process
const onEditProcess = (e) => {
  e.preventDefault();
  isShowContextProcess.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;
};
const onProcessUp = () => {
  companyStore.upProcess(props.process.rowIdx);
};
const onProcessDown = () => {
  companyStore.downProcess(props.process.rowIdx);
};
const onProcessDelete = () => {
  companyStore.removeProcess(props.process.id);
};

// Material
const onEditMaterial = (e, material) => {
  e.preventDefault();
  isShowContextMaterial.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;

  currentMaterial = material;
};
const onMaterialUp = () => {
  if (currentMaterial) {
    companyStore.upMaterial(props.process.id, currentMaterial.rowIdx);
  }
};
const onMaterialDown = () => {
  if (currentMaterial) {
    companyStore.downMaterial(props.process.id, currentMaterial.rowIdx);
  }
};
const onMaterialDelete = () => {
  if (currentMaterial) {
    companyStore.removeMaterial(props.process.id, currentMaterial.id);
  }
};

// Material
const onEditCompany = (e, company) => {
  e.preventDefault();
  isShowContextCompany.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;

  currentCompany = company;
};
const onCompanyUp = () => {
  if (currentCompany) {
    companyStore.upCompany(props.process.id, currentCompany.materialId, currentCompany.rowIdx);
  }
};
const onCompanyDown = () => {
  if (currentCompany) {
    companyStore.downCompany(props.process.id, currentCompany.materialId, currentCompany.rowIdx);
  }
};
const onCompanyDelete = () => {
  if (currentCompany) {
    companyStore.removeCompany(props.process.id, currentCompany.materialId, currentCompany.id);
  }
};
</script>

<style lang="scss" scoped>
.kfo2 {
  &-col-process {
    @apply px-3 py-2 border-r border-b border-b-line2 border-line;
    min-width: 9rem;
  }
  &-col-material {
    @apply px-3 py-2 border-r border-line;
    min-width: 9rem;
  }
  &-col-company {
    @apply px-3 py-2 border-r border-line;
  }
}
</style>
